import styled from 'styled-components'

const BadgeWarning = styled.span`
  display: inline-block;
  padding: 0.125em 0.5em;
  font-size: 0.625rem;
  font-weight: ${({ theme: { fontWeight } }) => fontWeight.semibold};
  line-height: 1;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  background: linear-gradient(180deg, rgba(238, 94, 48, 0.9) 0%, rgba(238, 94, 48, 0.54) 100%);
  box-shadow: 0px 4px 4px rgba(238, 94, 48, 0.25);
  border-radius: 24px;
  border-radius: 24px;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out,
    box-shadow 0.15s ease-in-out;
  color: #f7fcff;
  /* color: ${({ theme: { colors } }) => colors.warnText}; */
  text-transform: uppercase;
`
export default BadgeWarning
